"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Color = void 0;

var RGBColor_1 = require("./RGBColor");

var SRGBColor_1 = require("./SRGBColor");

var XYZColor_1 = require("./XYZColor");

var LABColor_1 = require("./LABColor");

var HSLColor_1 = require("./HSLColor");
/**
 * A wrapper `Color` class to represent various color formats
 * and manage conversions between them.
 * @remarks The current work on defining color management in web (including conversion algorithms)
 * can be tracked in this draft: https://drafts.csswg.org/css-color/
 */


var Color = /*#__PURE__*/function () {
  function Color() {
    _classCallCheck(this, Color);

    if (arguments.length === 1) {
      var c = arguments.length <= 0 ? undefined : arguments[0];

      if (c instanceof SRGBColor_1.SRGBColor) {
        this.srgbColor = c;
      } else if (c instanceof RGBColor_1.RGBColor) {
        this.rgbColor = c;
        this.srgbColor = c.toSRGB();
      } else if (c instanceof HSLColor_1.HSLColor) {
        this.hslColor = c;
        this.srgbColor = c.toSRGB();
      } else if (c instanceof XYZColor_1.XYZColor) {
        this.xyzColor = c;
        this.rgbColor = c.toRGB();
        this.srgbColor = this.rgbColor.toSRGB();
      } else if (c instanceof LABColor_1.LABColor) {
        this.labColor = c;
        this.xyzColor = c.toXYZ();
        this.rgbColor = this.xyzColor.toRGB();
        this.srgbColor = this.rgbColor.toSRGB();
      } else if (typeof c === "string") {
        this.srgbColor = SRGBColor_1.SRGBColor.ParseHex(c);
      } else {
        throw new Error("Wrong arg type. Expected one of the '***Color' types.");
      }
    } else if (arguments.length === 3) {
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "number" && typeof (arguments.length <= 1 ? undefined : arguments[1]) === "number" && typeof (arguments.length <= 2 ? undefined : arguments[2]) === "number") {
        this.srgbColor = new SRGBColor_1.SRGBColor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      } else {
        throw new Error("Wrong arg type. Expected 3 args of the 'number' type.");
      }
    } else {
      throw new Error("Wrong args for Color constructor.");
    }
  }

  _createClass(Color, [{
    key: "sRGB",
    get: function get() {
      return this.srgbColor;
    }
  }, {
    key: "RGB",
    get: function get() {
      if (this.rgbColor === undefined) {
        this.rgbColor = this.srgbColor.toRGB();
      }

      return this.rgbColor;
    }
  }, {
    key: "XYZ",
    get: function get() {
      if (this.xyzColor === undefined) {
        this.xyzColor = this.RGB.toXYZ();
      }

      return this.xyzColor;
    }
  }, {
    key: "LAB",
    get: function get() {
      if (this.labColor === undefined) {
        this.labColor = this.XYZ.toLAB();
      }

      return this.labColor;
    }
  }, {
    key: "HSL",
    get: function get() {
      if (this.hslColor === undefined) {
        this.hslColor = this.srgbColor.toHSL();
      }

      return this.hslColor;
    }
  }]);

  return Color;
}();

exports.Color = Color;